<template>
  <div style="margin-left:-4px;">
    <v-parallax  style="height:100%; width:unset" :src="require('@/assets/books.jpg')">
    <div style="overflow:hidden; height:unset; width:100vw">
    <v-img contain style="max-height:200px" :src="require('@/assets/transparent-temp-logo-with-title.png')"></v-img>
    <v-img style="max-height:142px; align-items:center;" contain :src="require('../assets/name_frame_mid_ready.png')">
      <div style="max-width:100vw; max-height:142px">
        <h1 :style="`text-align:center; color:white; font-size:${fontsize}`">Welcome to The Akashic Paths</h1>
        <div style="text-align:center; color:white">The first TTRP of its kind</div>
      </div>
    </v-img>
      <v-row justify="space-around" style="padding-top:150px; padding-bottom:150px">

        <v-col md="3" xs="4">
          <v-card class="background" style="min-height:500px">            
            <v-img style="height:80px; margin-top:6px; align-items:center" contain :src="require('../assets/name_frame_mid_ready.png')">
              <v-card-title class="headline" style="justify-content:center; font-size:38px!important; color:white">Play Game!</v-card-title>
            </v-img>
              <v-card-text style="text-align:center; font-size:18px; color:white">
                Welcome to the Akashic Paths, a website made to play a roguelike variation of pathfinder 1e, and the first table top game of its kind.
                <br/><br/>By blending table top combat and roguelike systems only capable in a digital medium like video games a brand new kind of game is born!
                <br/><br/>Perfect for any occasion! Want to give your GM a break? Want to introduce some new players to pathfinder? Just love the game and want to play it on a weekly basis? Play Akashic Paths! Setting up, playing, and running an Akashic Paths game is as simple as can be, and provides unbelievable replayability.
                <br/><br/>So try it right now for free!
                <br/><a href="/play">Play Now</a>
              </v-card-text>       
          </v-card>
        </v-col>
        
        <v-col md="3" xs="4">
          <v-card class="background" style="min-height:500px">
            <v-img style="height:80px; margin-top:6px; align-items:center" contain :src="require('../assets/name_frame_mid_ready.png')">
              <v-card-title class="headline" style="justify-content:center; font-size:38px!important; color:white; text-align:center">Get Fame!</v-card-title>   
            </v-img>
              <v-card-text style="text-align:center; font-size:18px;color:white">
                With a new and challenging style of gameplay, put your pathfinder and cooperation skills to the test. 
                <br/><br/>Gather a team of 3-6 players, and take on monsters of all challenge ratings in this familiar but different TTRPG, and claim your spot of eternal glory in the hall of fame.
                <br/><br/>With each run your abilities are based on RNG and rarity systems, so you can never guarantee you will get what you want, but it is guaranteed you will have a one of a kind experience. Learning to create combos with your own abilities and your teams abilities is key if you want to survive the Akashic Paths.
                <br/><br/> Join the Official Discord to show off your run!
                <br/><a href="https://discord.gg/ZTrp4aS7C3">Join</a>
              </v-card-text>
          </v-card>
        </v-col>

        <v-col md="3" xs="4">
          <v-card class="background" style="min-height:500px">
            <v-img style="height:80px; margin-top:6px; align-items:center" contain :src="require('../assets/name_frame_mid_ready.png')">
              <v-card-title class="headline" style="justify-content:center; font-size:38px!important; color:white">Acquire Dame!</v-card-title>
            </v-img>   
              <v-card-text style="text-align:center; font-size:18px; color:white">
                Akashic Paths has 650+ perks and class abilities, 150+ weapons and armor, 1500+ spells, 850+ maneuvers, 1000+ feats, 220+ weapon and armor enchantments to explore, with many rebalanced for the game mode, and plenty more perks made just for the game. 
                <br/><br/>Explore the vast build and rarity systems, amass and stack common and rare perks like auspicious mark for little boosts to your rolls, while creating powerful synergies to your unique perks like flurry of blows or channel energy. Every character in the Akashic Paths will be one of a kind.
                <br/><br/>Check out the guides for setting up your game and learning what kind of wild abilities await you in the Akashic Paths
                <br/><a href="/rules/introduction">Guides</a>
              </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="!mobile" style="margin-bottom:200px;align-items:center; text-align:-webkit-center">
        <v-img :src="require('../assets/fat bar 2.png')" contain height="375px" width="600px" style="align-items:center">
        <v-row style="align-items:center; max-width:1000px">
          <v-col sm="12" md="5" style="text-align:center; margin-right:100px">
          <div>
            <v-row style="text-align:center;">             
              <v-col cols="11" class="mr-0 pr-0">
                <h1 style="color:white">Check Out Some <br/>Akashic Path's Videos! </h1>
              </v-col>
              <v-col cols="1" style="color:white; align-self:center; max-width:15px" class="ml-0 pl-0">
                <h1>:</h1>
              </v-col>
            </v-row>
          </div>
          </v-col>
          <v-col sm="12" style="margin-top:4px; margin-right:12px;display:contents">
            <v-row style="justify-content:end; margin-right:8px">
              <v-icon color="white" @click="videoTab--">arrow_back_ios</v-icon>
              <v-tabs-items v-model="videoTab">
                <v-tab-item v-for="video in videos" :key="video" >
                  <iframe width="420" height="315" 
                    :src="video">
                  </iframe>
                </v-tab-item>
              </v-tabs-items>
              <v-icon color="white" @click="videoTab++">arrow_forward_ios</v-icon>
            </v-row>
          </v-col>
        </v-row>
        </v-img>
      </v-row>


      <v-row v-else justify="space-around" style="margin-bottom:200px;align-items:center; text-align:-webkit-center; width:100%;" class="mx-0">
        <v-card :img="require('../assets/fat bar 2.png')" style="min-height:450px; background-size: 100% 100%; background-repeat:no-repeat; background-position-y: center; background-position-x: center;">
          <v-card-title class="headline" style="justify-content:center; font-size:30px!important; color:white; text-align:center; margin-top:24px; white-space:break-spaces; word-break:break-word; padding-left: 32px; padding-right: 32px;">Check Out Some Akashic Path's Videos! </v-card-title>   
          <v-col sm="12" style="margin-top:4px; margin-right:12px;display:contents">
            <v-row style="justify-content:center;">
              <v-icon color="white" @click="videoTab--">arrow_back_ios</v-icon>
              <v-tabs-items v-model="videoTab">
                <v-tab-item v-for="video in videos" :key="video" >
                  <iframe v-if="orientation == 'landscape'" width="420" height="315" 
                    :src="video">
                  </iframe>

                  <iframe v-else width="300" height="200" 
                    :src="video">
                  </iframe>
                </v-tab-item>
              </v-tabs-items>
              <v-icon color="white" @click="videoTab++">arrow_forward_ios</v-icon>
            </v-row>
          </v-col>
          </v-card>
      </v-row>
    </div>
    </v-parallax> 
  </div>     
</template>
<script>
import {
VRow,
VCol,
VCard,
VCardTitle,
VCardText,
VParallax,
VImg,
VTabItem,
VTabsItems,
VIcon,
} from "vuetify/lib";
export default {
  components: {    
    VRow,
    VCol,
    VCard,
    VCardTitle,
    VCardText,
    VParallax,
    VImg,
    VTabItem,
    VTabsItems,
    VIcon,
  },
  data(){
    return{
      videos:['https://youtube.com/embed/plbEGbmMgBI', 'https://www.youtube.com/embed/ituYqeIduPk', 'https://www.youtube.com/embed/Nk5iOk1PR_M', 'https://www.youtube.com/embed/YLxX_giGpF4', 'https://www.youtube.com/embed/llVfL-sYbWc'],
      videoTab: 0,
      mobile:false,
    }
  },
  mounted(){
    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        this.mobile = true
    }
  },
  computed:{
    fontsize(){
      if(window.innerWidth < 541){
        return "1.3em"
      }else{
        return "2em"
      }
    },    
    orientation(){
      if(window.innerWidth < window.innerHeight) return "portrait"
      else return "landscape" 
    },
    
  },
  watch:{
    videoTab(){
      if(this.videoTab > this.videos.length-1) this.videoTab = 0
      if(this.videoTab < 0) this.videoTab = this.videos.length-1
    }
  },
  methods:{
    
  }
  
}
</script>
<style>
.background{
    background: url('../assets/big_bar.png');
    background-size: 100% 100%;
    background-repeat:no-repeat;
    background-position-y: center;
    background-position-x: center;
}
.v-parallax__image-container{
  contain:unset!important;
  width:100vw;
  height:40vh;  
}
.v-parallax__content{
  padding-left:4px;
  
}
</style>